import { render, staticRenderFns } from "./NoRecordCard.vue?vue&type=template&id=ff111614&"
import script from "./NoRecordCard.vue?vue&type=script&lang=js&"
export * from "./NoRecordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports